import { useEffect, useRef } from "react";

export default function useTrackOnce(track: () => void, shouldTrack: boolean) {
  const hasTrackedRef = useRef(false);
  const trackRef = useRef(track);
  trackRef.current = track;

  useEffect(() => {
    if (!shouldTrack || hasTrackedRef.current) return;

    hasTrackedRef.current = true;
    trackRef.current();
  }, [shouldTrack]);
}
